export default "__VITE_ASSET__Bfjqd6st__"